import React from "react";
import CultureFlag from "./CultureFlag";

interface Props {
  culture: server.dto.Culture
}

const CultureLabel = ({ culture }: Props) => {
  return <div className="flex gap">
    <div>
      <CultureFlag lcid={culture.lcid} size="small" />
    </div>
    <div>{culture.text}</div>
  </div>;
};

export default CultureLabel;